import { API_URL } from "../setting";

export const logoutUrl = API_URL + '/auth/logout'